module.exports = __webpack_public_path__ + "static/media/pooch.12dd1432.jpeg";